<!--表单组件-->
<template>
  <div class="form-wrapper">
    <el-form :inline-message="true" :model="form" class="mb20" :rules="fileds.ruleValidate" ref="form" :label-width="fileds.formLabelWidth">
      <el-form-item v-for="(filed, $index) in fileds.formFileds" :label="filed.title" :key="$index" :prop="filed.name" :required="filed.required">

        <el-input v-if="filed.type === 'number' && filed.range===true" :min="filed.min" :maxlength="filed.maxlength" :style="filed.style" :rows="filed.rows" :type="filed.type" :disabled="filed.disabled" v-model="filed.value" :placeholder="filed.placeholder"><template slot="append" v-if="filed.unit">{{filed.unit}}</template></el-input>

        <el-input v-else-if="filed.type === 'text' || filed.type === 'textarea' || filed.type === 'password' || filed.type === 'number'" :maxlength="filed.maxlength" :style="filed.style" :rows="filed.rows" :type="filed.type" :disabled="filed.disabled" v-model="filed.value" :placeholder="filed.placeholder"><template slot="append" v-if="filed.unit">{{filed.unit}}</template></el-input>
        <el-select :style="filed.style" v-if="filed.type === 'select'" v-model="filed.value" :placeholder="filed.placeholder" :disabled="filed.disabled" clearable filterable :allow-create="filed.allowCreate">
          <el-option v-if="filed.isHaveAll === true" :label='filed.allOptions.label' :value="filed.allOptions.value" :key="filed.allOptions.value">{{filed.allOptions.label}}
          </el-option>
          <el-option v-for="(selectItem, selectIndex) in filed.options" :label="selectItem.label" :value="selectItem.value" :key="selectIndex" :disabled="selectItem.disabled"></el-option>
        </el-select>
        <!-- <div v-if="filed.type === 'div'" style="display: flex;">
          <el-select v-model="filed.value" multiple  placeholder="可购买周期" style="width: 15%">
            <el-option
              v-for="(selectItem, selectIndex) in filed.options"
              :key="selectIndex"
              :label="selectItem.label"
              :value="selectItem.value">
            </el-option>
          </el-select>
          <div style="padding-left: 5px; padding-right: 5px">出售，最多每天可售卖</div>
          <el-input
            type="text"
            v-model="filed.value"
            style="width: 8%; margin-right: 5px"
          >
          </el-input>
          <div style="padding-right: 5px">张，总库存为</div>
          <el-input
            type="text"
            v-model="filed.value"
            style="width: 8%;  margin-right: 5px"
          >
          </el-input>
          <div>张</div>
        </div> -->
        <el-radio-group :style="filed.style" v-if="filed.type === 'radio'" v-model="filed.value" :disabled="filed.disabled" @change="handlerRadioChange(filed)">
          <el-radio v-for="(radio, index) in filed.options" :label="radio.value" :key="index">{{radio.label}}</el-radio>
        </el-radio-group>
        <el-date-picker :style="filed.style" v-if="filed.type === 'date' || filed.type === 'datetime'" :type="filed.type" v-model="filed.value" :value-format="filed.format" :placeholder="filed.placeholder" :disabled="filed.disabled"></el-date-picker>
        <div v-if="filed.type === 'file'" class="posterUrl-wrapper">
          <div style="position: relative;width: 302px;" @click="handlerUploadClick(filed)">
            <div class="upload-image-wrapper upload-wrapper-tw">
              <div class="upload-image-add">+</div>
              <div>上传海报</div>
            </div>
            <img :src="filed.value" class="image image-tw" v-if="filed.value !== ''">
          </div>
          <vue-image-core-upload field="file"
            @crop-success="handlerCropSuccess"
            @crop-upload-success="handlerCropUploadSuccess"
            @crop-upload-fail="handlerCropUploadFail"
            v-model="uploadShow"
            :width="filed.uploadSetting.width"
            :height="filed.uploadSetting.height"
            :noCircle="true"
            :langExt="{preview: '图片预览'}"
            :ref="filed.uploadSetting.refName"
            url="/api/upload/schedule/image.json">
          </vue-image-core-upload>
        </div>
        <div v-if="filed.type === 'download'">
          <a v-for="(file,index) in filed.value" :key="index" :href="file.url" :download="file.title">{{file.title}}<br></a>
        </div>
        <div v-if="filed.type === 'checkbox'">
          <div class="checkAll-container"><el-checkbox v-if="filed.haveCheckAll" v-model="filed.checkAll" @change="handleCheckAllChange(filed)" :disabled="filed.disabled">{{filed.checkAllTitle}}</el-checkbox></div>
          <el-checkbox-group  v-model="filed.value" :disabled="filed.disabled" :style="filed.style" @change="handleCheckBoxChange(filed)">
            <el-checkbox v-for="(radio, index) in filed.options" :label="radio.value" :key="index">{{radio.label}}</el-checkbox>
          </el-checkbox-group>
        </div>

        <div v-if="filed.type === 'preOrderTime'"  >
          <div style="display:flex;align-items:center">
            <el-input style="width:10%;margin-right:10px;" v-model="filed.value" :placeholder="filed.placeholder" :disabled="filed.disabled">
            </el-input>
            <div class="preOrderDay-button" :class="{'preOrderDay-active': preOrderType==1,'disabled':filed.disabled}" @click="handlePreOrderType(1,filed.disabled)">天</div>
            <div class="preOrderDay-button" :class="{'preOrderDay-active': preOrderType==2,'disabled':filed.disabled}" @click="handlePreOrderType(2,filed.disabled)">小时</div>
          </div>
        </div>

        <!--连接的表单-->
        <div v-if="filed.linkFiled && (filed.value === link.isShow)" v-for="(link, index) in filed.linkFiled" :key="index" :class="link.class" style="position: relative;">
          <el-form-item :prop="link.name" :label="link.title">
            <el-input :style="link.style" v-if="link.type === 'text' || link.type === 'number'" :type="link.type" v-model="link.value" :placeholder="link.placeholder" :disabled="filed.disabled"><template slot="append" v-if="link.unit">{{link.unit}}</template></el-input>
            <el-date-picker :style="link.style" v-if="link.type === 'date' || link.type === 'datetime' || link.type === 'dates'" :type="link.type" v-model="link.value" :value-format="link.format" :placeholder="link.placeholder" :disabled="filed.disabled"></el-date-picker>
            <div v-if="link.type === 'radio'" :style="link.style">
<!--               {{link.value}} -->
              <span style="font-size: 13px;">{{link.childTitle}}</span>

              <el-radio-group v-model="link.value" :disabled="link.disabled"  >
                <el-radio v-for="(radio, index) in link.options" :label="radio.value" :key="index">{{radio.label}}</el-radio>
              </el-radio-group>
            </div>

            <el-select :style="link.style" v-if="link.type === 'select'" v-model="link.value" :placeholder="link.placeholder" :disabled="link.disabled">
              <el-option v-for="(selectItem, selectIndex) in link.options" :label="selectItem.label" :value="selectItem.value" :key="selectIndex"></el-option>
            </el-select>

            <div v-if="link.type === 'sellLimit'" style="display: flex;">
              <div style="padding-right: 5px">产品</div>
              <el-select v-model="link.value" @change="sellSelectChange(link.options)" multiple  placeholder="可购买周期" style="width: 15%" :disabled="link.disabled">
                <el-option
                  v-for="(selectItem, selectIndex) in link.options"
                  :key="selectIndex"
                  :disabled="selectItem.disabled"
                  :label="selectItem.label"
                  :value="selectItem.value"
                  >
                </el-option>
              </el-select>
              <!-- <el-cascader
              style="width: 15%; height: 20px"
              @change="cascaserChange()"
              @remove-tag="cascaserExpandChange()"
              placeholder="可购买周期"
              :options="cascaserOptions"
              :props="link.props"
              v-model="link.value"
              :key="cascaderKey"
              clearable></el-cascader> -->
              <div style="padding-left: 5px; padding-right: 5px">出售，{{dataName}}最多可售卖</div>
              <el-input
                type="text"
                v-model="link.sellDayCount"
                style="width: 8%; margin-right: 5px"
                :disabled="link.disabled"
              >
              </el-input>
              <div style="padding-right: 5px">张，总库存为</div>
              <el-input
                type="text"
                v-model="link.sellAllCount"
                style="width: 8%;  margin-right: 5px"
                :disabled="link.disabled"
              >
              </el-input>
              <div>张</div>
            </div>

            <div v-if="link.type === 'sellDayLimit'" style="display: flex;flex-direction:column;">
              <div style="display:flex;">
                <div style="padding-left: 5px; padding-right: 5px">每天最多可售卖</div>
                <div style="width:18%">
                  <el-input
                    type="text"
                    v-model="link.sellDayCount2"
                    style="width: 100%; margin-right: 5px"
                    :disabled="link.disabled"
                  >
                  </el-input>
                </div>
              <div style="padding-left: 5px; padding-right: 5px">张</div>
              </div>
                <div><span style="color:#ec0000;font-size:10px">设置每天售卖库存请前往产品列表页-售卖情况</span></div>
            </div>

            <div v-if="link.type === 'buyLimit'" style="display: flex;">
              <div style="padding-right: 5px">用户</div>
              <!-- <el-select v-model="link.value" multiple  placeholder="可购买周期" style="width: 15%">
                <el-option
                  v-for="(selectItem, selectIndex) in link.options"
                  :key="selectIndex"
                  :label="selectItem.label"
                  :value="selectItem.value">
                </el-option>
              </el-select> -->
              <!-- <el-cascader
              style="width: 15%; height: 20px"
              @change="cascaserChange(link.options, link.cascaderKey)"
              placeholder="可购买周期"
              :options="link.options"
              :props="link.props"
              v-model="link.value"
              clearable></el-cascader> -->
              <el-select v-model="link.value" @change="customerSelectChange(link.options)" multiple  placeholder="可购买周期" style="width: 13%" :disabled="customerLimitDisable||link.disabled">
                <el-option
                  v-for="(selectItem, selectIndex) in link.options"
                  :key="selectIndex"
                  :disabled="selectItem.disabled"
                  :label="selectItem.label"
                  :value="selectItem.value">
                </el-option>
              </el-select>
              <div style="padding-left: 5px; padding-right: 5px">可购买</div>
              <el-input
                type="text"
                v-model="link.customerBuyOrderCount"
                style="width: 6%; margin-right: 5px"
                :disabled="link.disabled"
              >
              </el-input>
              <div style="padding-right: 5px">次，每次可购买</div>
              <el-input
                type="text"
                v-model="link.customerBuyTicketCount"
                style="width: 6%;  margin-right: 5px"
                :disabled="link.disabled"
              >
              </el-input>
              <div>张</div>
              <div style="padding-left: 5px; padding-right: 5px">，最多可购买</div>
              <el-input
                type="text"
                v-model="link.customerBuyCount"
                style="width: 8%;  margin-right: 5px"
                :disabled="link.disabled"
              >
              </el-input>
              <div>张</div>
            </div>

          </el-form-item>
          <el-tooltip v-if="link.tooltip" :style="link.toolStyle" class="item" effect="dark" :content="link.tooltipText" :placement="link.tooltipPosition">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </div>
        <el-tooltip v-if="filed.tooltip" :style="tooltipStyle" class="item" effect="dark" :content="filed.tooltipText" :placement="filed.tooltipPosition">
          <i class="el-icon-question"></i>
        </el-tooltip>
      </el-form-item>
    </el-form>
    <div v-if="button" :class="{textAlign: buttonAlign}">
      <el-button v-for="(btn, index) in button.list" :type="btn.type" size="small" :key="index" :style="button.style" @click="handlerButton(btn)">{{btn.title}}</el-button>
    </div>
  </div>
</template>

<script>
/*
  @author: zhengxiaobei
  @date: 2018/06/10
  @desc: 'form表单'
  @params:
    props:
      fileds: 所有表单的数据
      button: 表单按钮
      dataSource: 默认数据源
      disabledFileds: 表单不可修改字段
    data:
      form: 生成表单字段的数据源
*/
import VueImageCoreUpload from 'vue-image-crop-upload'
import _ from 'lodash'

export default {
  name: 'w-form',
  components: {
    VueImageCoreUpload
  },
  props: {
    fileds: Object,
    button: Object,
    dataSource: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabledFileds: {
      type: Object,
      default: () => {
        return {}
      }
    },
    tooltipStyle: {
      type: Object,
      default: () => {
        return {
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          left: '59%',
          fontSize: '20px'
        }
      }
    },
    buttonAlign: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      form: {},
      uploadShow: false,
      currentFileds: {},
      currentUploadRefName: '',
      sellLimitType: 0,
      customerLimitType: 0,
      customerLimitDisable: false,
      dataName: '每天',
      preOrderType: 1
    }
  },
  methods: {
    dealFiledsData (object, fn) {
      Object.keys(object).map(fn)
    },
    handlerUploadClick (data) {
      this.currentFileds = data.name // 存储当前表单上传图片的字段
      this.currentUploadRefName = data.uploadSetting.refName // 存储当前上传图片空间的ref
      this.uploadShow = true
    },
    handlerCropSuccess (imgDataUrl) {
      this.$showFullScreenLoading()
    },
    handlerCropUploadFail () {
      this.$tryHideFullScreenLoading()
    },
    sellSelectChange (data) {
      if (this.param.sellLimit && this.param.sellLimit.length === 0) {
        this.dataName = '每天'
        data[0].disabled = false
        data[1].disabled = false
        data[2].disabled = false
        data[3].disabled = false
        data[4].disabled = false
        data[5].disabled = false
        data[6].disabled = false
        data[7].disabled = false
        data[8].disabled = false
      }
      if (this.param.sellLimit && this.param.sellLimit[0] === -1) {
        this.dataName = '每天'
        data[0].disabled = false
        data[1].disabled = true
        data[2].disabled = true
        data[3].disabled = true
        data[4].disabled = true
        data[5].disabled = true
        data[6].disabled = true
        data[7].disabled = true
        data[8].disabled = true
      }

      if (this.param.sellLimit && this.param.sellLimit[0] === 0) {
        this.dataName = '每周'
        data[0].disabled = true
        data[1].disabled = false
        data[2].disabled = true
        data[3].disabled = true
        data[4].disabled = true
        data[5].disabled = true
        data[6].disabled = true
        data[7].disabled = true
        data[8].disabled = true
      }
      if (this.param.sellLimit && this.param.sellLimit[0] > 0) {
        this.dataName = '每天'
        data[0].disabled = true
        data[1].disabled = true
        data[2].disabled = false
        data[3].disabled = false
        data[4].disabled = false
        data[5].disabled = false
        data[6].disabled = false
        data[7].disabled = false
        data[8].disabled = false
      }

      if (this.customerLimitDisable) {
        this.fileds.formFileds.customerLimitType.linkFiled.customerLimit.value = this.fileds.formFileds.sellLimitType.linkFiled.sellLimit.value
      }
    },
    customerSelectChange (data) {
      if (this.param.customerLimit && this.param.customerLimit.length === 0) {
        data[0].disabled = false
        data[1].disabled = false
        data[2].disabled = false
        data[3].disabled = false
        data[4].disabled = false
        data[5].disabled = false
        data[6].disabled = false
        data[7].disabled = false
        data[8].disabled = false
      }
      if (this.param.customerLimit && this.param.customerLimit[0] === -1) {
        data[0].disabled = false
        data[1].disabled = true
        data[2].disabled = true
        data[3].disabled = true
        data[4].disabled = true
        data[5].disabled = true
        data[6].disabled = true
        data[7].disabled = true
        data[8].disabled = true
      }

      if (this.param.customerLimit && this.param.customerLimit[0] === 0) {
        data[0].disabled = true
        data[1].disabled = false
        data[2].disabled = true
        data[3].disabled = true
        data[4].disabled = true
        data[5].disabled = true
        data[6].disabled = true
        data[7].disabled = true
        data[8].disabled = true
      }
      if (this.param.customerLimit && this.param.customerLimit[0] > 0) {
        data[0].disabled = true
        data[1].disabled = true
        data[2].disabled = false
        data[3].disabled = false
        data[4].disabled = false
        data[5].disabled = false
        data[6].disabled = false
        data[7].disabled = false
        data[8].disabled = false
      }
    },
    handlerCropUploadSuccess (res) {
      this.$tryHideFullScreenLoading()
      let { code, msg, data } = res
      if (code === 0) {
        this.$set(
          this.fileds.formFileds[this.currentFileds],
          'value',
          data.url
        )
      } else {
        this.$message({ message: msg, type: 'error' })
      }
      this.uploadShow = false
      if (this.$refs[this.currentUploadRefName]) {
        // 将上传图片的空间关闭(使其回到上传第一步)
        this.$refs[this.currentUploadRefName][0].off()
      }
      this.currentFileds = {}
      this.currentUploadRefName = ''
    },
    handlerButton (btn) {
      if (btn.fn === 'close') {
        this.reset()
        this.$emit('buttonClick', btn, this.form)
        return
      }
      this.$refs['form'].validate(valid => {
        if (valid) {
          // if (this.form.sellLimitType === '1') {
          //   if ((!this.form.sellLimit || this.form.sellLimit.length === 0) && !this.form.sellDayCount && !this.form.sellAllCount) {
          //     this.$message({ message: '售卖限制不能同时为空', type: 'error' })
          //     return
          //   }
          //   let reg = /(^[1-9]\d*$)/
          //   this.form.sellDayCount += ''
          //   if (this.form.sellDayCount.length > 0 && !reg.test(this.form.sellDayCount)) {
          //     this.$message({ message: '每天最多可售卖数量要大于0或者为空', type: 'error' })
          //     return
          //   }
          //   this.form.sellAllCount += ''
          //   if (this.form.sellAllCount.length > 0 && !reg.test(this.form.sellAllCount)) {
          //     this.$message({ message: '总库存要大于0或者为空', type: 'error' })
          //     return
          //   }
          // } else if (this.form.sellLimitType === '2') {
          //   this.form.sellDayCount2 += ''
          //   let reg = /(^[1-9]\d*$)/
          //   if (!this.form.sellDayCount2.length || !reg.test(this.form.sellDayCount2)) {
          //     this.$message({ message: '每天最多可售卖数量必须大于0', type: 'error' })
          //     return
          //   }
          //   this.form.sellAllCount = ''
          //   this.form.sellDayCount = this.form.sellDayCount2
          //   this.form.sellLimit = []
          //   this.form.sellLimit.push(-1)
          // } else {
          //   this.form.sellAllCount = ''
          //   this.form.sellDayCount = ''
          //   this.form.sellLimit = []
          //   this.form.sellLimit.push(-1)
          // }

          // if (this.form.customerLimitType === '1') {
          //   if ((!this.form.customerLimit || this.form.customerLimit.length === 0) && !this.form.customerBuyOrderCount && !this.form.customerBuyTicketCount && !this.form.customerBuyCount) {
          //     this.$message({ message: '购卖限制不能同时为空', type: 'error' })
          //     return
          //   }
          // }

          // this.form.preOrderTime += ''
          // if (!this.form.preOrderTime.length) {
          //   this.form.preOrderType = ''
          // } else {
          //   this.form.preOrderType = this.preOrderType
          //   let reg = /(^[1-9]\d*$)/
          //   let reg2 = /^(([^0][0-9]+|0|[1-9])\.([5]{1}))$/
          //   if (this.preOrderType === 1 && !reg.test(this.form.preOrderTime)) {
          //     this.$message({ message: '提前下单天数必须是整数', type: 'error' })
          //     return
          //   }
          //   // console.log(this.form.preOrderTime)
          //   // console.log(reg2.test(this.form.preOrderTime))
          //   // console.log(reg.test(this.form.preOrderTime))
          //   if (this.preOrderType === 2 && !reg2.test(this.form.preOrderTime) && !reg.test(this.form.preOrderTime)) {
          //     this.$message({ message: '提前下单小时数必须是半小时的整数倍', type: 'error' })
          //     return
          //   }
          // }
          // console.log(this.form)
          let form = Object.assign({}, this.form)
          this.$emit('buttonClick', btn, form)
          this.reset()
        } else {
          console.log('error submit!')
        }
      })
    },
    reset () {
      this.form = {}
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields()
      }
      this.dealFiledsData(this.fileds.formFileds, val => {
        let item = this.fileds.formFileds[val] // 拿到当前object
        item.value = ''
        if (item.linkFiled !== undefined) {
          this.dealFiledsData(item.linkFiled, key => {
            item.linkFiled[key].value = ''
          })
        }
      })
    },
    handlerRadioChange (filed) {
      // 售卖限制选中状态
      if (filed.name === 'sellLimitType') {
        this.sellLimitType = parseInt(filed.value)
        if (this.sellLimitType === 1) {
          this.fileds.formFileds.sellLimitType.linkFiled.sellLimit.value = null
          for (
            let i = 0;
            i <
            this.fileds.formFileds.sellLimitType.linkFiled.sellLimit.options
              .length;
            i++
          ) {
            this.fileds.formFileds.sellLimitType.linkFiled.sellLimit.options[ i ].disabled = false
          }
        } else if (this.sellLimitType === 2) {
          this.fileds.formFileds.sellLimitType.linkFiled.sellDayLimit.sellDayCount = 0
        }
      }

      // 购买限制选中状态
      if (filed.name === 'customerLimitType') {
        this.customerLimitType = parseInt(filed.value)
        if (this.customerLimitType) {
          this.fileds.formFileds.customerLimitType.linkFiled.customerLimit.value = null
          for (
            let i = 0;
            i <
            this.fileds.formFileds.customerLimitType.linkFiled.customerLimit
              .options.length;
            i++
          ) {
            this.fileds.formFileds.customerLimitType.linkFiled.customerLimit.options[ i ].disabled = false
          }
        }
      }

      if (filed.linkFiled) {
        _.map(filed.linkFiled, (item, key) => {
          if (item.isShow !== filed.value) {
            item.value = null
          } else {
            item.value = item.defaultValue
          }
        })
      }

      // 购买限制时间选择是否可用
      this.customerLimitDisable =
        this.sellLimitType === 1 && this.customerLimitType === 1

      if (this.customerLimitDisable) {
        this.fileds.formFileds.customerLimitType.linkFiled.customerLimit.value = this.fileds.formFileds.sellLimitType.linkFiled.sellLimit.value
      }
    },
    handleCheckAllChange (filed) {
      if (!filed.checkAll) {
        filed.value = []
      } else {
        let array = []
        for (let key in filed.options) {
          array.push(filed.options[key].value)
        }
        filed.value = array
      }
    },
    handleCheckBoxChange (filed) {
      if (filed.value.length !== filed.options.length) {
        filed.checkAll = false
      } else {
        filed.checkAll = true
      }
    },
    onSellLimitChange (e) {
      console.log(e)
    },
    handlePreOrderType (t, disabled) {
      if (disabled) {
        return
      }
      this.preOrderType = t
    },
    init () {
      this.reset()
      // 拿到不可修改的所有字段
      let disabledFileds = Object.keys(this.disabledFileds)
      this.dealFiledsData(this.fileds.formFileds, val => {
        let item = this.fileds.formFileds[val] // 拿到当前object
        item.disabled = false
        // 如果有数据源并且数据源里有当前key,给其value赋值
        if (
          Object.keys(this.dataSource).length > 0 &&
          this.dataSource.hasOwnProperty(val)
        ) {
          // 如果数据源的当前值为数字并且当前标签为radio, 将数字改为字符串
          if (
            typeof this.dataSource[val] === 'number' &&
            item.type === 'radio'
          ) {
            item.value = this.dataSource[val] + ''
            // 如果数据源的当前值为数字并且当前标签为select, 将数字改为字符串
          } else if (
            typeof this.dataSource[val] === 'number' &&
            item.type === 'select'
          ) {
            item.value = this.dataSource[val] + ''
          } else {
            item.value = this.dataSource[val]
          }
          if (item.type === 'checkbox' && item.haveCheckAll) {
            if (item.value.length === item.options.length) {
              item.checkAll = true
            }
          }
          // 如果有连带的字段跟上一致
          if (item.linkFiled !== undefined) {
            this.dealFiledsData(item.linkFiled, key => {
              // if (item.linkFiled.sellLimit) {
              //   item.linkFiled.sellLimit.sellDayCount = this.dataSource.sellDayCount
              //   item.linkFiled.sellLimit.sellAllCount = this.dataSource.sellAllCount
              //   this.param.sellLimit = this.dataSource.sellLimit
              //   this.sellSelectChange(item.linkFiled.sellLimit.options)
              // }
              // if (item.linkFiled.sellDayLimit) {
              //   // item.linkFiled.sellDayLimit.sellDayCount = this.dataSource.sellDayCount
              //   item.linkFiled.sellDayLimit.sellDayCount2 = this.dataSource.sellDayCount
              //   // this.param.sellDayLimit = this.dataSource.sellDayLimit
              //   // this.param.sellDayCount = item.linkFiled.sellDayLimit.sellDayCount
              //   this.param.sellDayCount2 = item.linkFiled.sellDayLimit.sellDayCount2
              // }
              // if (item.linkFiled.customerLimit) {
              //   item.linkFiled.customerLimit.customerBuyOrderCount = this.dataSource.customerBuyOrderCount
              //   item.linkFiled.customerLimit.customerBuyTicketCount = this.dataSource.customerBuyTicketCount
              //   item.linkFiled.customerLimit.customerBuyCount = this.dataSource.customerBuyCount
              //   this.param.customerLimit = this.dataSource.customerLimit
              //   this.customerSelectChange(item.linkFiled.customerLimit.options)
              // }
              item.linkFiled[key]['disabled'] = false
              item.linkFiled[key].value = this.dataSource[key]
              item.linkFiled[key].defaultValue = this.dataSource[key]
              if (
                typeof this.dataSource[key] === 'string' &&
                item.linkFiled[key].type === 'dates'
              ) {
                // 如果type为dates(多个日期并且为string), 将其转换为数组赋值
                item.linkFiled[key].value = JSON.parse(this.dataSource[key])
                item.linkFiled[key].defaultValue = JSON.parse(
                  this.dataSource[key]
                )
              }
              if (
                disabledFileds.indexOf(key) > -1 &&
                this.disabledFileds[key]['position'] === 'two-level'
              ) {
                // 如果disabledFileds匹配当前项并且位置为'two-level',则将其disabled赋为不可修改
                this.$set(
                  this.fileds.formFileds[val]['linkFiled'][key],
                  'disabled',
                  true
                )
              }
            })
          }
        }
        if (disabledFileds.length > 0) {
          // 如果disabledFileds匹配当前项并且位置为'one-level',则将其disabled赋为不可修改
          if (
            disabledFileds.indexOf(val) > -1 &&
            this.disabledFileds[val]['position'] === 'one-level'
          ) {
            this.$set(this.fileds.formFileds[val], 'disabled', true)
          }
        }
        let key = item.name
        this.form[key] = item.value || null
        if (item.linkFiled) {
          Object.keys(item.linkFiled).map(valFiled => {
            if (item.value === item.valueOflinkFiled) {
              // 当前值等于连接值,证明链接值显示,则赋值到最终form上
              this.form[valFiled] = item.linkFiled[valFiled].value || null
            }
          })
        }
        if (!this.dataSource.preOrderType) {
          this.preOrderType = 1
        } else {
          this.preOrderType = this.dataSource.preOrderType
        }
      })
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    param () {
      let data = {}
      this.dealFiledsData(this.fileds.formFileds, k => {
        let item = this.fileds.formFileds[k]
        if (item.hasOwnProperty('name')) {
          data[item.name] = item.value
        }
        if (this.fileds.formFileds[k].linkFiled) {
          // if (item.linkFiled.sellLimit) {
          //   data.sellDayCount = item.linkFiled.sellLimit.sellDayCount
          //   data.sellAllCount = item.linkFiled.sellLimit.sellAllCount
          // }
          // if (item.linkFiled.sellDayLimit) {
          //   // data.sellDayCount = item.linkFiled.sellDayLimit.sellDayCount
          //   data.sellDayCount2 = item.linkFiled.sellDayLimit.sellDayCount2
          // }
          // if (item.linkFiled.customerLimit) {
          //   data.customerBuyOrderCount = item.linkFiled.customerLimit.customerBuyOrderCount
          //   data.customerBuyTicketCount = item.linkFiled.customerLimit.customerBuyTicketCount
          //   data.customerBuyCount = item.linkFiled.customerLimit.customerBuyCount
          // }
          Object.keys(this.fileds.formFileds[k].linkFiled).map(valFiled => {
            if (item.value === item.valueOflinkFiled) {
              data[valFiled] = this.fileds.formFileds[k].linkFiled[ valFiled ].value
            }
          })
        }
      })
      return data
    }
  },
  watch: {
    param (n, o) {
      this.form = this.param
    },
    dataSource (v) {
      this.dataSource = v
      this.init()
    },
    disabledFileds (v) {
      this.disabledFileds = v
      this.$nextTick(() => {
        this.init()
      })
    }
  }
}
</script>

<style lang="sass">
  .linkedForm
    margin-left: -240px
  .checkAll-container
    height: 25px
  .checkAll-container label
    margin-bottom: 0
  .el-select__tags
    padding: 0 20px
  .preOrderDay-button
    border: 1px solid #e8e8e8
    background-color: #e8e8e8
    color: #cccccc
    height: 30px
    line-height: 30px
    min-width: 40px
    text-align: center
    cursor: pointer
  .preOrderDay-active
    border: 1px solid #26DDC5
    background-color: #26DDC5
    color: #ffffff
  .disabled
    cursor: no-drop
</style>



// WEBPACK FOOTER //
// src/components/base/form.vue